import { ICatalogInfo, ICountries, IData, IDataPagination, IFilterForm } from 'interfaces/selectClient';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { login } from 'store/reducers/useSlices';
import { useAppDispatch } from 'utils/hooks/redux';
import useHttp from 'utils/hooks/useHttp';
import SelectClientView from './SelectClient.view';
import useLogOut from 'utils/hooks/useLogOut';
import { IOption } from '../../../../interfaces/select';
import { fetchCatalogInfo } from 'store/reducers/catalog/catalogs.actions';

type Props = {};

const SelectClient: React.FC<Props> = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const http = useHttp();
  const [catalogInfo, setCatalogInfo] = useState<ICatalogInfo | null>(null);
  const [responseClient, setResponseClient] = useState<IDataPagination & IData[]>();
  const [countries, setcountries] = useState<ICountries[]>([]);
  const [curentPage, setCurentPage] = useState<number>(0);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingSaveClient, setLoadingSaveClient] = useState<boolean>(false);
  const [infoClients, setInfoClients] = useState<IData[]>([]);
  const [componentMounted, setComponentMounted] = useState<boolean>(true);
  const { getValues, register, handleSubmit, reset, control } = useForm<IFilterForm>();
  const [valueCountries, setValueCountries] = useState<IOption | null>(null);
  const [clientIdForSpinner, setClientIdForSpinner] = useState<number>(Number(localStorage.getItem('clientId')) || 0);
  const [searchParams] = useSearchParams();
  const [openModalClientId, setOpenModalClientId] = useState<number>(0);
  const navigate = useNavigate();
  const logout = useLogOut();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (componentMounted) {
      feachRequest();
      getCatalogInfo();
    }
  }, []);
  useEffect(() => {
    if (responseClient) {
      setLoading(true);
      setCurentPage(Number(searchParams.get('page')));
      setTotalPage(responseClient.total_pages);
      setInfoClients(responseClient.data);
      setLoading(false);
    }
  }, [responseClient]);

  const optionsCountries = () => {
    return (
      countries?.map((item) => ({
        label: item.name,
        value: item.id,
      })) || []
    );
  };

  const onSubmit = async () => {
    setLoading(true);
    const data = getValues();

    await feachSelectClient(data);
    setLoading(false);
  };

  const resetFilter = async () => {
    resetData();

    const data = getValues();

    await feachSelectClient(data);
  };

  function resetData() {
    setLoading(true);
    setLoading(false);
    setValueCountries(null);
    reset({ name: '' });
    setLoading(false);
  }

  const feachSelectClient = async (param: IFilterForm) => {
    setLoading(true);
    const responseClient = await http.selectClient.selectClient(param);

    setResponseClient(responseClient.data);
  };

  function getCatalogInfo() {
    http.selectClient.getCatalogInfo().then((res) => {
      setCatalogInfo(res.data);
      localStorage.setItem('catalog', JSON.stringify(res.data));
    });
  }

  const feachRequest = async () => {
    Promise.all([feachSelectClient({ page: Number(searchParams.get('page')) }), http.selectClient.countries()])
      .then((res) => {
        setcountries(res[1].data);
      })
      .finally(() => {
        setLoading(false);
        setComponentMounted(false);
      });
  };

  const handlePageClick = async (page: number) => {
    setLoading(true);
    const selectPage = page;
    const params = getValues();

    await feachSelectClient({ ...params, page: selectPage });
    setLoading(false);
  };

  const handleSelectClient = async (clientId: number) => {
    setClientIdForSpinner(clientId);
    setLoadingSaveClient(true);
    localStorage.setItem('clientId', String(clientId));
    await http.selectClient.saveClientForSeller(clientId);
    const user = await http.user.infoUser();

    localStorage.setItem('userData', JSON.stringify(user.data));
    dispatch(login(user.data));
    setLoadingSaveClient(false);
    catalogInfo?.id && dispatch(fetchCatalogInfo(catalogInfo?.id));
    navigate(`/catalog/${catalogInfo?.id}`);
  };

  return (
    <SelectClientView
      catalogInfo={catalogInfo}
      curentPage={curentPage}
      totalPage={totalPage}
      infoClients={infoClients}
      openModal={openModal}
      handlePageClick={handlePageClick}
      setOpenModal={setOpenModal}
      loading={loading}
      optionsCountries={optionsCountries()}
      handleSubmit={handleSubmit}
      onSubmit={onSubmit}
      register={register}
      resetFilter={resetFilter}
      control={control}
      valueCountries={valueCountries}
      setValueCountries={setValueCountries}
      handleSelectClient={handleSelectClient}
      loadingSaveClient={loadingSaveClient}
      clientIdForSpinner={clientIdForSpinner}
      logout={logout}
      openModalClientId={openModalClientId}
      setOpenModalClientId={setOpenModalClientId}
    />
  );
};

SelectClient.displayName = 'SelectClient';

export default SelectClient;
